const FINANCE_VALUE_ROLES = new Set(['admin', 'financeiro'])
const FINANCE_CLOSED_SCOPE_ROLES = new Set(['admin', 'financeiro', 'manager'])

export function canViewFinanceFinancialValues(role: string | undefined | null): boolean {
  return FINANCE_VALUE_ROLES.has((role ?? '').toLowerCase())
}

export function canViewFinanceClosedScope(role: string | undefined | null): boolean {
  return FINANCE_CLOSED_SCOPE_ROLES.has((role ?? '').toLowerCase())
}

export function isFinanceGestorRole(role: string | undefined | null): boolean {
  return (role ?? '').toLowerCase() === 'manager'
}
